import React, { useEffect } from "react";
import { RiCheckboxCircleLine } from "react-icons/ri";
import { useDispatch } from "react-redux";

import AlertInline from "components/layout/AlertInline";
import { Section, SuccessContainer } from "./styles";
import { resetStateNewUnit } from "store/actions/add-new-unit-actions";

import { HeaderContainer } from "../styles";

const SuccessRegister = (): JSX.Element => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetStateNewUnit());
    };
  }, []);

  return (
    <Section>
      <HeaderContainer>
        <h1>Tudo certo!!</h1>
        <h2>
          Agora você pode acessar sua unidade na barra lateral esquerda, basta
          clicar para abrir e selecioná-la.
        </h2>
      </HeaderContainer>

      <SuccessContainer>
        <RiCheckboxCircleLine size={60} />
        <p>Unidade adicionada com sucesso.</p>
      </SuccessContainer>

      <AlertInline
        text="Em até 60 dias você receberá seu primeiro boleto."
        textFontSize="0.8rem"
      />
    </Section>
  );
};

export default SuccessRegister;
